module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/57b9b3d6444c297bb69a434d8b98b662.png";